<template>
  <section v-for="(bloque, index) in content" :key="index">
    <suspense>
      <div class="go1-pb-4">
        <component :is="bloque.type" :data="bloque.data" />
      </div>
      <template #fallback>
        <Loader />
      </template>
    </suspense>
  </section>
</template>
<script setup>
import { onMounted, ref } from "vue";

import Loader from "@/components/extra/Loader.vue";
import Paquetes from "@/components/Paquetes.vue";
import Destinos from "@/components/Destinos.vue";
import Descabrazos from "@/components/Descabrazos.vue";
import Hoteles from "@/components/Hoteles.vue";
import Genericos from "@/components/Genericos.vue";
import Textos from "@/components/Textos.vue";
import HotelesPaquetes from "@/components/HotelesPaquetes.vue";

let content = ref([]);
onMounted(async () => {
  const data = await fetch(window.apiUri + "/api/quote/page/" + window.id);
  content.value = await data.json();
});
</script>
<script>
export default {
  components: {
    Paquetes,
    Destinos,
    Descabrazos,
    Hoteles,
    Genericos,
    Textos,
    HotelesPaquetes,
  },
};
</script>

<style>
h1 {
  color: #333;
}

h2 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
}
</style>
